import { render, staticRenderFns } from "./AddDocumentModal.vue?vue&type=template&id=7607af62&"
import script from "./AddDocumentModal.vue?vue&type=script&lang=js&"
export * from "./AddDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7607af62')) {
      api.createRecord('7607af62', component.options)
    } else {
      api.reload('7607af62', component.options)
    }
    module.hot.accept("./AddDocumentModal.vue?vue&type=template&id=7607af62&", function () {
      api.rerender('7607af62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/AddDocumentModal.vue"
export default component.exports